module.exports = __webpack_public_path__ + "static/media/mickey.529238d1.png";